import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingInlineEnd: 56,
      paddingInlineStart: 56,

      '@media (max-width: 1180px)': {
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
      },
    },
    bold: {
      fontWeight: 'bold',
    },
    emptyReportMessageContainer: {
      marginTop: 140,
    },
    margin: {
      marginTop: 63,
    },
    reportTable: {
      '@media (max-width: 1023px)': {
        display: 'none',
      },
    },
    arrowIcon: {
      color: variables.cadetBlue,
    },
    subTitle: {
      textAlign: 'start',
      marginLeft: 43,
      marginBottom: 16,

      '@media (max-width: 600px)': {
        marginLeft: 5,
      },
    },
    quickReports: {
      maxWidth: '14.25%',
      flexBasis: '14.25%',
      borderRight: `0.5px solid ${variables.black10}`,

      '@media (max-width: 1180px)': {
        width: 150,
        maxWidth: 150,
        flexBasis: 'unset',
        display: 'inline-block',
        whiteSpace: 'pre-line',
      },
    },
    panels: {
      marginTop: 16,
      marginBottom: 16,

      '@media (max-width: 1180px)': {
        display: 'block',
        overflowX: 'scroll',
        whiteSpace: 'nowrap',
      },
    },
  }),
);
